import { SelectOption } from 'naive-ui';
import { ref, watch } from 'vue';
import { http } from './http.service';
import { EthersService as eth } from './ethers.service';

export const arenaOptions = ref<SelectOption[]>([]);
export const participantCountOptions = ref<SelectOption[]>([]);
export const houndPackName = ref<string>('My Hounds');

// http.service.axios.baseUrl is now dependent on selected metamask network
watch(() => eth.reactive.value.network, (network) => {
  http.getArenas({}).then(res => {
    try {
      arenaOptions.value = res[0].map(arena => ({
        label: arena.name,
        value: arena.token_id
      }))
    } catch(err) {
      console.log(err);
    }
  });
  
  http.getParticipantValues().then(res => {
    participantCountOptions.value = res.map(pOption => ({
      label: `${pOption} participants`,
      value: pOption
    }));
  });
});

export const resetUserPreferences = () => {
  http.getUserPreferences(eth.userAddress).then(res => {
    houndPackName.value = res.pack_name;
  }).catch(_ => {
    houndPackName.value = 'My Hounds';
  });
};

watch(() => eth.reactive.value.userAddress, (_) => {
  resetUserPreferences();
});
